<template>
    <div class="floor brand">
		
        <!-- 楼层内容区 -->
        <div class="floor-content">
			<div class="title">
				<router-link to="/brand">
					<img src="@/assets/images/index/index4_13.jpg">
				</router-link>
			</div>
			<div class="list" >
				<div class="item" v-for="(item,index) in brandList" :key="index" @click="tobrand(item)">
					<el-image fit="contain" class="imgae" :src="$img(item.image_url)" @error="item.image_url = defaultGoodsImage" />
					<p>{{item.brand_name}}</p>
				</div>
			</div>
			<div class="ad">
				<router-link to="/brand">
					<img src="@/assets/images/index/index4_15.jpg">
				</router-link>
			</div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import { floorGoods, brandList } from "@/api/goods/goods"
	
    export default {
        name: "brand",
        components: {
        },
        props: {
            config: {
                type: Object,
                // required: true
            }
        },
        data() {
            return {
                floorConfig: {
                    validated: false,
                    rightCargos: []
                },
                brandList: []
            }
        },
        created() {
            this.$store.dispatch("site/defaultFiles")
            this.getBrandList()
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            tobrand(item) {
                if (item) {
                    this.$router.pushToTab(`/list?brand_id=${item.brand_id}`)
                }
            },
            getBrandList() {
                // const sku_ids = this.floorConfig.rightCargos
                //     .map(item => {
                //         return item.sku_id
                //     })
                //     .toString()
				
                brandList({
					page_size:18
				})
                    .then(res => {
                        this.brandList = res.data.list
                    })
                    .catch(err => {})
            }
        },
        watch: {
            config: {
                handler: function(curr) {
                    if (curr && curr.rightCargos) {
                        this.floorConfig = { ...curr, validated: true }
                    }
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .floor {
		width: 1210px;
        .floor-content {
            display: flex;
            flex-wrap: wrap;
			.title{
				width: 200px;
				height: 340px;
				background-color: #03A9F4;
				img{
					width: 100%;
					height: 340px;
				}
			}
			.list{
				width: 815px;
				// display: flex;
				// flex-flow: wrap;
				background-color: #F5F5F5;
				padding: 0 5px;
				box-sizing: border-box;
				display: block;
				.item:nth-child(6n+1){
					margin-left: 0;
				}
				.item{
					width: 130px;
					margin: 0 0 5px 5px;
					// width: 16%;
					background-color: #fff;
					float: left;
					height: 110px;
					// margin-bottom: 7px;
					// margin: 0 auto 5px auto;
					.imgae{
						width: 92px;
						height: 48px;
						// height: auto;
						margin: 20px auto 10px auto;
						display: block;
					}
					p{
						text-align: center;
						line-height: 30px;
					}
				}
			}
			.ad{
				width: 195px;
				height: 340px;
				background-color: #8BC34A;
				img{
					width: 100%;
					height: 340px;
				}
			}
        }
    }
</style>
